import * as React from 'react';
import { SVGProps } from 'react';

const SvgRecentSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.999 9.725h-6.404l2.588-2.663c-2.578-2.55-6.753-2.644-9.331-.094a6.506 6.506 0 0 0 0 9.256c2.578 2.55 6.753 2.55 9.331 0 1.284-1.275 1.927-2.758 1.927-4.628h1.889c0 1.87-.831 4.297-2.493 5.941-3.315 3.287-8.698 3.287-12.013 0-3.306-3.277-3.334-8.604-.019-11.881s8.632-3.277 11.947 0l2.578-2.654v6.725zm-8.028-2.003v4.014l3.306 1.965-.68 1.143-4.042-2.399V7.723h1.417z" />
  </svg>
);

export default SvgRecentSearch;
